import { render, staticRenderFns } from "./detailClaim.vue?vue&type=template&id=b25ac036&scoped=true&"
import script from "./detailClaim.vue?vue&type=script&lang=js&"
export * from "./detailClaim.vue?vue&type=script&lang=js&"
import style0 from "./detailClaim.vue?vue&type=style&index=0&id=b25ac036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25ac036",
  null
  
)

export default component.exports